export const REOPEN_CONVERSATION_GET = `REOPEN_CONVERSATION_GET`;
export const REOPEN_CONVERSATION_POST = `REOPEN_CONVERSATION_POST`;

export const REOPEN_CONVERSATION_RES = `REOPEN_CONVERSATION_RES`;
